import script from "./UserNameCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserNameCell.vue?vue&type=script&setup=true&lang=ts"

import "./UserNameCell.vue?vue&type=style&index=0&id=60aea6b1&lang=scss"

const __exports__ = script;

export default __exports__